import { render, staticRenderFns } from "./AjandaInfo.vue?vue&type=template&id=ef602644"
import script from "./AjandaInfo.vue?vue&type=script&lang=ts"
export * from "./AjandaInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports